import { isTauri } from '@tauri-apps/api/core';

// eslint-disable-next-line no-shadow-restricted-names
declare const globalThis: ServiceWorkerGlobalScope & WorkerGlobalScope & SharedWorkerGlobalScope & Window;

export const IS_MULTIACCOUNT_SUPPORTED = 'SharedWorker' in globalThis;
export const IS_INTL_LIST_FORMAT_SUPPORTED = 'ListFormat' in Intl;
// Probe for browsers that mis-parse custom (non-special) URL schemes — any such scheme works here.
export const IS_BAD_URL_PARSER = new URL('omni://host').host !== 'host';

export const IS_TAURI = isTauri();
// @ts-expect-error no types for electron
export const IS_ELECTRON = Boolean(globalThis.electron);

// Rough hardware tier, used to size the animation and media-playback budgets. `hardwareConcurrency`
// is the only signal every engine reports; `deviceMemory` is Chromium-only, so a missing value must
// never be read as "low end" — it can pull the tier down, never up.
const FALLBACK_CORE_COUNT = 8;
const MIN_TIER_CORES = 2;
const MIN_TIER_MEMORY_GB = 2;
const MID_TIER_CORES = 4;
const MID_TIER_MEMORY_GB = 4;

const deviceMemoryGb = (navigator as { deviceMemory?: number }).deviceMemory;

export const CPU_CORE_COUNT = navigator.hardwareConcurrency || FALLBACK_CORE_COUNT;
export const IS_LOW_END_DEVICE = CPU_CORE_COUNT <= MIN_TIER_CORES
  || (deviceMemoryGb !== undefined && deviceMemoryGb <= MIN_TIER_MEMORY_GB);
export const IS_MID_END_DEVICE = !IS_LOW_END_DEVICE && (CPU_CORE_COUNT <= MID_TIER_CORES
  || (deviceMemoryGb !== undefined && deviceMemoryGb <= MID_TIER_MEMORY_GB));
